/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1076
 */

var r = require(/* 194 */"../../1648/194")
var o = require(/* 1077 */"../../1650/86/1077")
var i = r["__core-js_shared__"] || o("__core-js_shared__", {})
module.exports = i
